const StepVisibility = Object.freeze({
  VISIBLE: 'visible',
  SEEN: 'seen',
  NOTSEEN: 'notSeen',
});

export default StepVisibility;
